module.exports = __webpack_public_path__ + "img/sm-152036.png";